/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
    // const noop = (): void => {
    //     /* silenced in production */
    // };
    // window.console.log = noop;
    // window.console.debug = noop;
    // window.console.info = noop;
    // window.console.warn = noop;
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        ngZoneEventCoalescing: true,
    })
    .catch((err) => console.error(err));
